<template>
  <li
    class="list-item"
    :class="[`list-item--${textAlign}-${iconPosition}`, {
      'list-item--clickable': clickable,
    }]"
  >
    <div
      v-if="iconPosition == 'left'"
      class="list-item__icon list-item__icon-left"
    >
      <img
        v-if="iconUrl"
        :src="iconUrl"
      >
      <slot
        v-else
        name="list-item-icon"
      />
    </div>

    <div :class="['list-item__text', `list-item__text--${textAlign}`]">
      <slot name="list-item-text" />
    </div>

    <div
      v-if="iconPosition == 'right'"
      class="list-item__icon list-item__icon-right"
    >
      <img
        v-if="iconUrl"
        :src="iconUrl"
      >
      <slot
        v-else
        name="list-item-icon"
      />
    </div>
  </li>
</template>

<script>
export default {
  props: {
    'iconPosition': {
      type: String,
      default: null,
      validator: (value) => ['left', 'right', null].includes(value),
    },
    'iconUrl': {
      type: String,
      default: undefined,
    },
    'textAlign': {
      type: String,
      default: 'left',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.list-item + .list-item {
  margin-top: 0.5rem;
}
.list-item {
  border-radius: 0.5rem;
  background-color: white;
  display: flex;
  flex-direction: row;
}
.list-item--clickable {
  cursor: pointer;
}
.list-item--left-left {
  justify-content: flex-start;
}
.list-item--left-right {
  justify-content: space-between;
}
.list-item--right-left {
  justify-content: space-between;
}
.list-item--right-right {
  justify-content: flex-end;
}
.list-item__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
}
.list-item__text--left {
  text-align: left;
}
.list-item__text--right {
  text-align: right;
}
.list-item__icon {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.list-item__icon img {
  height: 5rem;
  max-width: initial;
}
</style>
